var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('template-modal',{ref:"templateModal"}),_c('b-button',{attrs:{"size":"sm","variant":"light"},on:{"click":_vm.press}},[_c('icon',{attrs:{"name":"mdi.plus"}}),_vm._v(" Insert Template ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }